/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-components/blob/master/LICENSE.md for details.
 * v1.0.0-beta.82
 */
import { I as Icon, d as defineCustomElement$1 } from './icon.js';

const CalciteIcon = Icon;
const defineCustomElement = defineCustomElement$1;

export { CalciteIcon, defineCustomElement };
